import(/* webpackMode: "eager" */ "/app/node_modules/@dxp-feed/gigya/dist/components/login.component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@dxp-feed/gigya/dist/providers/gigyaProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@dxp-feed/ui/dist/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/utils/fonts/index.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":[\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-secondary\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/utils/fonts/index.ts\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/utils/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fontello/fontello.woff2\",\"weight\":\"normal\",\"style\":\"normal\"}],\"variable\":\"--font-fontello\",\"display\":\"swap\"}],\"variableName\":\"fontello\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@dxp-feed/ui/dist/index.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SelectRegionOverlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/helper/cdpSDK.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangProvider"] */ "/app/src/utils/hooks/context/lang.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegionProvider"] */ "/app/src/utils/hooks/context/region.tsx");
